export const twoFactorExpirySafetyMs = 5 * 1000;

export function getTwoFactorExpiryDelayMs(expiresAt: number, now = Date.now()): number {
    return Math.max(0, expiresAt - twoFactorExpirySafetyMs - now);
}

export function isTwoFactorChallengeExpired(expiresAt?: number, now = Date.now()): boolean {
    return !!expiresAt && getTwoFactorExpiryDelayMs(expiresAt, now) === 0;
}
